.root {
  margin: 0;
  font-weight: bold;
  letter-spacing: 0.025em;
  font-size: 2.25rem;
  line-height: 2.5rem;
}
